var map = {
	"./de/intros/letterKnowledge-intro.mp3": 17926,
	"./de/intros/pd-intro.mp3": 85457,
	"./de/intros/phonemeIsolation-klarte-oppgaver.mp3": 55001,
	"./de/intros/phonemeIsolation-starter-intro.mp3": 91025,
	"./de/intros/testen-er-ferdig.mp3": 74891,
	"./de/intros/workingmemory-numbers-intro.mp3": 56052,
	"./de/intros/workingmemory-words-intro.mp3": 65578,
	"./de/spoonerism/correct-1.mp3": 54810,
	"./de/spoonerism/correct-2.mp3": 87237,
	"./de/spoonerism/correct-3.mp3": 34500,
	"./de/spoonerism/incorrect-1.mp3": 27645,
	"./de/spoonerism/incorrect-2.mp3": 75642,
	"./de/spoonerism/incorrect-3.mp3": 20219,
	"./de/spoonerism/intro-end.mp3": 29976,
	"./de/spoonerism/intro.mp3": 75382,
	"./de/spoonerism/proveoppgave-1.mp3": 28675,
	"./de/spoonerism/proveoppgave-2.mp3": 67948,
	"./de/spoonerism/proveoppgave-3.mp3": 64801,
	"./nn/dictation/diktat-12.mp3": 83074,
	"./nn/dictation/diktat-13.mp3": 86618,
	"./nn/dictation/diktat-15.mp3": 36859,
	"./nn/dictation/diktat-16.mp3": 47366,
	"./nn/dictation/diktat-17.mp3": 91863,
	"./nn/dictation/diktat-19.mp3": 59502,
	"./nn/dictation/diktat-21.mp3": 57210,
	"./nn/dictation/diktat-24.mp3": 68004,
	"./nn/dictation/diktat-28.mp3": 43889,
	"./nn/dictation/diktat-35.mp3": 56944,
	"./nn/dictation/diktat-36.mp3": 79662,
	"./nn/dictation/diktat-38.mp3": 92129,
	"./nn/dictation/diktat-39.mp3": 29784,
	"./nn/dictation/diktat-intro.mp3": 79032,
	"./nn/intros/letterKnowledge-intro.mp3": 25259,
	"./nn/intros/oneMinute-intro.mp3": 37932,
	"./nn/intros/pd-intro.mp3": 37238,
	"./nn/intros/phonemeIsolation-klarte-oppgaver.mp3": 28422,
	"./nn/intros/phonemeIsolation-starter-intro.mp3": 99110,
	"./nn/intros/testen-er-ferdig.mp3": 34137,
	"./nn/intros/workingmemory-numbers-intro.mp3": 62222,
	"./nn/intros/workingmemory-words-intro.mp3": 75381,
	"./nn/phonemeDeletion/brev-b.mp3": 24634,
	"./nn/phonemeDeletion/brev.mp3": 15146,
	"./nn/phonemeDeletion/broed-b.mp3": 84839,
	"./nn/phonemeDeletion/bru-r.mp3": 45975,
	"./nn/phonemeDeletion/bry-r.mp3": 63338,
	"./nn/phonemeDeletion/drap-d.mp3": 31690,
	"./nn/phonemeDeletion/foere-f.mp3": 36057,
	"./nn/phonemeDeletion/foere.mp3": 95638,
	"./nn/phonemeDeletion/gaas-g.mp3": 6312,
	"./nn/phonemeDeletion/gris-g.mp3": 98793,
	"./nn/phonemeDeletion/gris.mp3": 16165,
	"./nn/phonemeDeletion/klatre-t.mp3": 16842,
	"./nn/phonemeDeletion/klede-k.mp3": 45394,
	"./nn/phonemeDeletion/laas-s.mp3": 47873,
	"./nn/phonemeDeletion/lekse-k.mp3": 84532,
	"./nn/phonemeDeletion/loff-f.mp3": 62500,
	"./nn/phonemeDeletion/maal-m.mp3": 81145,
	"./nn/phonemeDeletion/malt-l.mp3": 55808,
	"./nn/phonemeDeletion/sel-l.mp3": 70889,
	"./nn/phonemeDeletion/sel.mp3": 39315,
	"./nn/phonemeDeletion/skyl-l.mp3": 32236,
	"./nn/phonemeDeletion/sport-p.mp3": 81775,
	"./nn/phonemeDeletion/trygg-t.mp3": 24397,
	"./nn/phonemeIsolation/ends_with_e.mp3": 37438,
	"./nn/phonemeIsolation/ends_with_i.mp3": 38140,
	"./nn/phonemeIsolation/ends_with_k.mp3": 24628,
	"./nn/phonemeIsolation/ends_with_n.mp3": 11123,
	"./nn/phonemeIsolation/ends_with_o.mp3": 77689,
	"./nn/phonemeIsolation/ends_with_p.mp3": 10079,
	"./nn/phonemeIsolation/ends_with_r.mp3": 82663,
	"./nn/phonemeIsolation/ends_with_t.mp3": 66075,
	"./nn/phonemeIsolation/ends_with_u.mp3": 14369,
	"./nn/phonemeIsolation/ends_with_y.mp3": 80437,
	"./nn/phonemeIsolation/starts_with_b.mp3": 25792,
	"./nn/phonemeIsolation/starts_with_e.mp3": 77217,
	"./nn/phonemeIsolation/starts_with_g.mp3": 2566,
	"./nn/phonemeIsolation/starts_with_h.mp3": 67505,
	"./nn/phonemeIsolation/starts_with_i.mp3": 64563,
	"./nn/phonemeIsolation/starts_with_k.mp3": 71579,
	"./nn/phonemeIsolation/starts_with_l.mp3": 16907,
	"./nn/phonemeIsolation/starts_with_oe.mp3": 94165,
	"./nn/phonemeIsolation/starts_with_s.mp3": 61997,
	"./nn/phonemeIsolation/starts_with_v.mp3": 44434,
	"./nn/rapidNaming/rapidNaming-intro1.mp3": 17375,
	"./nn/rapidNaming/rapidNaming-intro2.mp3": 18467,
	"./nn/rapidNaming/rapidNaming-intro3.mp3": 20455,
	"./nn/rapidNaming/rapidNaming-intro4.mp3": 27166,
	"./nn/rapidNaming/rapidNaming-intro5.mp3": 51731,
	"./nn/spoonerism/correct-1.mp3": 32838,
	"./nn/spoonerism/correct-2.mp3": 37366,
	"./nn/spoonerism/correct-3.mp3": 53101,
	"./nn/spoonerism/incorrect-1.mp3": 75628,
	"./nn/spoonerism/incorrect-2.mp3": 23874,
	"./nn/spoonerism/incorrect-3.mp3": 74833,
	"./nn/spoonerism/intro-end.mp3": 99186,
	"./nn/spoonerism/intro.mp3": 11203,
	"./nn/spoonerism/proveoppgave-1.mp3": 62306,
	"./nn/spoonerism/proveoppgave-2.mp3": 80591,
	"./nn/spoonerism/proveoppgave-3.mp3": 14947,
	"./nn/spoonerism/spoonerism-task (1).mp3": 90044,
	"./nn/spoonerism/spoonerism-task (10).mp3": 9821,
	"./nn/spoonerism/spoonerism-task (11).mp3": 44991,
	"./nn/spoonerism/spoonerism-task (2).mp3": 27314,
	"./nn/spoonerism/spoonerism-task (3).mp3": 40199,
	"./nn/spoonerism/spoonerism-task (4).mp3": 82105,
	"./nn/spoonerism/spoonerism-task (5).mp3": 88603,
	"./nn/spoonerism/spoonerism-task (6).mp3": 68266,
	"./nn/spoonerism/spoonerism-task (7).mp3": 75621,
	"./nn/spoonerism/spoonerism-task (8).mp3": 18093,
	"./nn/spoonerism/spoonerism-task (9).mp3": 73011,
	"./nn/spoonerism/unk-spoonerism-task ().mp3": 22176,
	"./nn/workingmemory_numbers/workingmemory-numbers-1.mp3": 97743,
	"./nn/workingmemory_numbers/workingmemory-numbers-10.mp3": 51656,
	"./nn/workingmemory_numbers/workingmemory-numbers-11.mp3": 80613,
	"./nn/workingmemory_numbers/workingmemory-numbers-12.mp3": 58884,
	"./nn/workingmemory_numbers/workingmemory-numbers-2.mp3": 55577,
	"./nn/workingmemory_numbers/workingmemory-numbers-3.mp3": 16439,
	"./nn/workingmemory_numbers/workingmemory-numbers-4.mp3": 76638,
	"./nn/workingmemory_numbers/workingmemory-numbers-5.mp3": 72634,
	"./nn/workingmemory_numbers/workingmemory-numbers-6.mp3": 61628,
	"./nn/workingmemory_numbers/workingmemory-numbers-7.mp3": 86834,
	"./nn/workingmemory_numbers/workingmemory-numbers-8.mp3": 68792,
	"./nn/workingmemory_numbers/workingmemory-numbers-9.mp3": 79673,
	"./nn/workingmemory_words/workingmemory-words-1.mp3": 87690,
	"./nn/workingmemory_words/workingmemory-words-10.mp3": 97715,
	"./nn/workingmemory_words/workingmemory-words-11.mp3": 20319,
	"./nn/workingmemory_words/workingmemory-words-12.mp3": 2499,
	"./nn/workingmemory_words/workingmemory-words-2.mp3": 83579,
	"./nn/workingmemory_words/workingmemory-words-3.mp3": 15409,
	"./nn/workingmemory_words/workingmemory-words-4.mp3": 47473,
	"./nn/workingmemory_words/workingmemory-words-5.mp3": 61606,
	"./nn/workingmemory_words/workingmemory-words-6.mp3": 96873,
	"./nn/workingmemory_words/workingmemory-words-7.mp3": 7709,
	"./nn/workingmemory_words/workingmemory-words-8.mp3": 60671,
	"./nn/workingmemory_words/workingmemory-words-9.mp3": 41614,
	"./no/dictation/diktat-0.mp3": 75572,
	"./no/dictation/diktat-1.mp3": 75785,
	"./no/dictation/diktat-10.mp3": 97268,
	"./no/dictation/diktat-11.mp3": 15235,
	"./no/dictation/diktat-12.mp3": 15110,
	"./no/dictation/diktat-13.mp3": 18428,
	"./no/dictation/diktat-14.mp3": 4112,
	"./no/dictation/diktat-15.mp3": 17067,
	"./no/dictation/diktat-16.mp3": 3889,
	"./no/dictation/diktat-17.mp3": 48656,
	"./no/dictation/diktat-18.mp3": 55981,
	"./no/dictation/diktat-19.mp3": 33071,
	"./no/dictation/diktat-2.mp3": 39671,
	"./no/dictation/diktat-20.mp3": 24045,
	"./no/dictation/diktat-21.mp3": 76165,
	"./no/dictation/diktat-22.mp3": 61662,
	"./no/dictation/diktat-23.mp3": 97062,
	"./no/dictation/diktat-24.mp3": 40726,
	"./no/dictation/diktat-25.mp3": 65745,
	"./no/dictation/diktat-26.mp3": 61153,
	"./no/dictation/diktat-27.mp3": 35246,
	"./no/dictation/diktat-28.mp3": 20594,
	"./no/dictation/diktat-29.mp3": 21320,
	"./no/dictation/diktat-3.mp3": 96378,
	"./no/dictation/diktat-30.mp3": 21277,
	"./no/dictation/diktat-31.mp3": 70286,
	"./no/dictation/diktat-32.mp3": 97538,
	"./no/dictation/diktat-33.mp3": 70169,
	"./no/dictation/diktat-34.mp3": 88649,
	"./no/dictation/diktat-35.mp3": 57780,
	"./no/dictation/diktat-36.mp3": 43221,
	"./no/dictation/diktat-37.mp3": 73193,
	"./no/dictation/diktat-38.mp3": 15238,
	"./no/dictation/diktat-39.mp3": 5744,
	"./no/dictation/diktat-4.mp3": 36527,
	"./no/dictation/diktat-5.mp3": 94601,
	"./no/dictation/diktat-6.mp3": 73342,
	"./no/dictation/diktat-7.mp3": 63249,
	"./no/dictation/diktat-8.mp3": 23485,
	"./no/dictation/diktat-9.mp3": 92752,
	"./no/dictation/diktat-intro.mp3": 27129,
	"./no/intros/letterKnowledge-intro.mp3": 88068,
	"./no/intros/oneMinute-intro.mp3": 32532,
	"./no/intros/pd-intro.mp3": 36334,
	"./no/intros/phonemeIsolation-klarte-oppgaver.mp3": 46537,
	"./no/intros/phonemeIsolation-starter-intro.mp3": 3676,
	"./no/intros/testen-er-ferdig.mp3": 49306,
	"./no/intros/workingmemory-numbers-intro.mp3": 93119,
	"./no/intros/workingmemory-words-intro.mp3": 86570,
	"./no/phonemeDeletion/brev-b.mp3": 58944,
	"./no/phonemeDeletion/brev.mp3": 18435,
	"./no/phonemeDeletion/bro-r.mp3": 38883,
	"./no/phonemeDeletion/bro.mp3": 9528,
	"./no/phonemeDeletion/broed-b.mp3": 22299,
	"./no/phonemeDeletion/broed.mp3": 12712,
	"./no/phonemeDeletion/brus-b.mp3": 22886,
	"./no/phonemeDeletion/bry-r.mp3": 30373,
	"./no/phonemeDeletion/bry.mp3": 94547,
	"./no/phonemeDeletion/dansk-k.mp3": 56495,
	"./no/phonemeDeletion/drap-d.mp3": 15087,
	"./no/phonemeDeletion/drap.mp3": 30510,
	"./no/phonemeDeletion/film-m.mp3": 78568,
	"./no/phonemeDeletion/foere-f.mp3": 85897,
	"./no/phonemeDeletion/foere.mp3": 55947,
	"./no/phonemeDeletion/gaas-g.mp3": 51302,
	"./no/phonemeDeletion/gaas.mp3": 92653,
	"./no/phonemeDeletion/gris-g.mp3": 488,
	"./no/phonemeDeletion/gris.mp3": 78063,
	"./no/phonemeDeletion/hans-s.mp3": 9511,
	"./no/phonemeDeletion/helst-l.mp3": 54136,
	"./no/phonemeDeletion/klaer-k.mp3": 19754,
	"./no/phonemeDeletion/klaer.mp3": 37546,
	"./no/phonemeDeletion/klart-t.mp3": 58187,
	"./no/phonemeDeletion/klatre-t.mp3": 82216,
	"./no/phonemeDeletion/klatre.mp3": 88523,
	"./no/phonemeDeletion/laas-s.mp3": 5670,
	"./no/phonemeDeletion/laas.mp3": 93711,
	"./no/phonemeDeletion/lekse-k.mp3": 83418,
	"./no/phonemeDeletion/lekse.mp3": 43967,
	"./no/phonemeDeletion/loff-f.mp3": 77800,
	"./no/phonemeDeletion/loff.mp3": 77347,
	"./no/phonemeDeletion/maal-m.mp3": 58408,
	"./no/phonemeDeletion/malt-l.mp3": 68840,
	"./no/phonemeDeletion/malt.mp3": 76788,
	"./no/phonemeDeletion/mars-r.mp3": 54178,
	"./no/phonemeDeletion/pris-p.mp3": 70770,
	"./no/phonemeDeletion/ris-r.mp3": 56130,
	"./no/phonemeDeletion/sel-l.mp3": 88504,
	"./no/phonemeDeletion/sel.mp3": 92960,
	"./no/phonemeDeletion/ser-r.mp3": 14113,
	"./no/phonemeDeletion/skyll-l.mp3": 24516,
	"./no/phonemeDeletion/skyll.mp3": 44569,
	"./no/phonemeDeletion/spoer-p.mp3": 24709,
	"./no/phonemeDeletion/sport-p.mp3": 25380,
	"./no/phonemeDeletion/sport.mp3": 38065,
	"./no/phonemeDeletion/stoev-s.mp3": 21735,
	"./no/phonemeDeletion/tap-p.mp3": 81833,
	"./no/phonemeDeletion/tekst-k.mp3": 88486,
	"./no/phonemeDeletion/trygg-t.mp3": 57647,
	"./no/phonemeDeletion/trygg.mp3": 96316,
	"./no/phonemeIsolation/ends_with_e.mp3": 80841,
	"./no/phonemeIsolation/ends_with_i.mp3": 35432,
	"./no/phonemeIsolation/ends_with_k.mp3": 95997,
	"./no/phonemeIsolation/ends_with_n.mp3": 8962,
	"./no/phonemeIsolation/ends_with_o.mp3": 57976,
	"./no/phonemeIsolation/ends_with_p.mp3": 25120,
	"./no/phonemeIsolation/ends_with_r.mp3": 16502,
	"./no/phonemeIsolation/ends_with_t.mp3": 13812,
	"./no/phonemeIsolation/ends_with_u.mp3": 62559,
	"./no/phonemeIsolation/ends_with_y.mp3": 34966,
	"./no/phonemeIsolation/starts_with_b.mp3": 96592,
	"./no/phonemeIsolation/starts_with_e.mp3": 70177,
	"./no/phonemeIsolation/starts_with_g.mp3": 51280,
	"./no/phonemeIsolation/starts_with_h.mp3": 18064,
	"./no/phonemeIsolation/starts_with_i.mp3": 36493,
	"./no/phonemeIsolation/starts_with_k.mp3": 54923,
	"./no/phonemeIsolation/starts_with_l.mp3": 37769,
	"./no/phonemeIsolation/starts_with_oe.mp3": 77773,
	"./no/phonemeIsolation/starts_with_s.mp3": 79672,
	"./no/phonemeIsolation/starts_with_v.mp3": 17740,
	"./no/rapidNaming/rapidNaming-intro1.mp3": 45152,
	"./no/rapidNaming/rapidNaming-intro2.mp3": 84391,
	"./no/rapidNaming/rapidNaming-intro3.mp3": 9680,
	"./no/rapidNaming/rapidNaming-intro4.mp3": 4437,
	"./no/rapidNaming/rapidNaming-intro5.mp3": 55257,
	"./no/spoonerism/correct-1.mp3": 30115,
	"./no/spoonerism/correct-2.mp3": 13170,
	"./no/spoonerism/correct-3.mp3": 23321,
	"./no/spoonerism/incorrect-1.mp3": 38712,
	"./no/spoonerism/incorrect-2.mp3": 36676,
	"./no/spoonerism/incorrect-3.mp3": 1286,
	"./no/spoonerism/intro-end.mp3": 25081,
	"./no/spoonerism/intro.mp3": 714,
	"./no/spoonerism/proveoppgave-1.mp3": 43069,
	"./no/spoonerism/proveoppgave-2.mp3": 49260,
	"./no/spoonerism/proveoppgave-3.mp3": 67240,
	"./no/spoonerism/spoonerism-task (1).mp3": 54280,
	"./no/spoonerism/spoonerism-task (10).mp3": 99710,
	"./no/spoonerism/spoonerism-task (11).mp3": 30790,
	"./no/spoonerism/spoonerism-task (12).mp3": 24976,
	"./no/spoonerism/spoonerism-task (13).mp3": 97206,
	"./no/spoonerism/spoonerism-task (14).mp3": 93380,
	"./no/spoonerism/spoonerism-task (15).mp3": 38178,
	"./no/spoonerism/spoonerism-task (16).mp3": 22319,
	"./no/spoonerism/spoonerism-task (17).mp3": 47381,
	"./no/spoonerism/spoonerism-task (18).mp3": 42587,
	"./no/spoonerism/spoonerism-task (19).mp3": 63524,
	"./no/spoonerism/spoonerism-task (2).mp3": 47953,
	"./no/spoonerism/spoonerism-task (20).mp3": 99624,
	"./no/spoonerism/spoonerism-task (3).mp3": 72914,
	"./no/spoonerism/spoonerism-task (4).mp3": 94297,
	"./no/spoonerism/spoonerism-task (5).mp3": 2742,
	"./no/spoonerism/spoonerism-task (6).mp3": 28799,
	"./no/spoonerism/spoonerism-task (7).mp3": 45527,
	"./no/spoonerism/spoonerism-task (8).mp3": 16716,
	"./no/spoonerism/spoonerism-task (9).mp3": 28222,
	"./no/workingmemory_numbers/workingmemory-numbers-1.mp3": 28835,
	"./no/workingmemory_numbers/workingmemory-numbers-10.mp3": 905,
	"./no/workingmemory_numbers/workingmemory-numbers-11.mp3": 1506,
	"./no/workingmemory_numbers/workingmemory-numbers-12.mp3": 57367,
	"./no/workingmemory_numbers/workingmemory-numbers-2.mp3": 45982,
	"./no/workingmemory_numbers/workingmemory-numbers-3.mp3": 67345,
	"./no/workingmemory_numbers/workingmemory-numbers-4.mp3": 4067,
	"./no/workingmemory_numbers/workingmemory-numbers-5.mp3": 63202,
	"./no/workingmemory_numbers/workingmemory-numbers-6.mp3": 86638,
	"./no/workingmemory_numbers/workingmemory-numbers-7.mp3": 47129,
	"./no/workingmemory_numbers/workingmemory-numbers-8.mp3": 18596,
	"./no/workingmemory_numbers/workingmemory-numbers-9.mp3": 54513,
	"./no/workingmemory_words/workingmemory-words-1.mp3": 40880,
	"./no/workingmemory_words/workingmemory-words-10.mp3": 22811,
	"./no/workingmemory_words/workingmemory-words-11.mp3": 73985,
	"./no/workingmemory_words/workingmemory-words-12.mp3": 37319,
	"./no/workingmemory_words/workingmemory-words-2.mp3": 48489,
	"./no/workingmemory_words/workingmemory-words-3.mp3": 91591,
	"./no/workingmemory_words/workingmemory-words-4.mp3": 55841,
	"./no/workingmemory_words/workingmemory-words-5.mp3": 48051,
	"./no/workingmemory_words/workingmemory-words-6.mp3": 95119,
	"./no/workingmemory_words/workingmemory-words-7.mp3": 51328,
	"./no/workingmemory_words/workingmemory-words-8.mp3": 16460,
	"./no/workingmemory_words/workingmemory-words-9.mp3": 63842,
	"./se/intros/NonWOrdInstruction.mp3": 34100,
	"./se/intros/NonWord-Intro-AFTER-trail-exercises.mp3": 46072,
	"./se/intros/SM_Intro-AFTER-trial.mp3": 28806,
	"./se/intros/SWFUC2-01.mp3": 44448,
	"./se/intros/Test-start.mp3": 27471,
	"./se/intros/letterKnowledge-intro.mp3": 78017,
	"./se/intros/oneMinute-intro.mp3": 57452,
	"./se/intros/phonemeIsolation-klarte-oppgaver.mp3": 97315,
	"./se/intros/phonemeIsolation-starter-intro.mp3": 1944,
	"./se/intros/setningsminne-intro.mp3": 67145,
	"./se/intros/testen-er-done.mp3": 11430,
	"./se/intros/testen-er-ferdig.mp3": 763,
	"./se/intros/workingmemory-numbers-intro-old.mp3": 85776,
	"./se/intros/workingmemory-numbers-intro.mp3": 1733,
	"./se/intros/workingmemory-words-intro-old.mp3": 17890,
	"./se/intros/workingmemory-words-intro.mp3": 79842,
	"./se/nonwordRepetition/adult/test/1.mp3": 52396,
	"./se/nonwordRepetition/adult/test/10.mp3": 98919,
	"./se/nonwordRepetition/adult/test/11.mp3": 22907,
	"./se/nonwordRepetition/adult/test/12.mp3": 1250,
	"./se/nonwordRepetition/adult/test/13.mp3": 14353,
	"./se/nonwordRepetition/adult/test/14.mp3": 20510,
	"./se/nonwordRepetition/adult/test/15.mp3": 43039,
	"./se/nonwordRepetition/adult/test/16.mp3": 22434,
	"./se/nonwordRepetition/adult/test/2.mp3": 36562,
	"./se/nonwordRepetition/adult/test/3.mp3": 5030,
	"./se/nonwordRepetition/adult/test/4.mp3": 70089,
	"./se/nonwordRepetition/adult/test/5.mp3": 77167,
	"./se/nonwordRepetition/adult/test/6.mp3": 10701,
	"./se/nonwordRepetition/adult/test/7.mp3": 72458,
	"./se/nonwordRepetition/adult/test/8.mp3": 80592,
	"./se/nonwordRepetition/adult/test/9.mp3": 31279,
	"./se/nonwordRepetition/adult/test/Si-ordet-en-gang-til.mp3": 30538,
	"./se/nonwordRepetition/adult/trial/Si-ordet-en-gang-til.mp3": 41754,
	"./se/nonwordRepetition/adult/trial/Trial 1(3)-kan-du-si-ordet-en-gang-til2.mp3": 12358,
	"./se/nonwordRepetition/adult/trial/Trial1-if-correct.mp3": 28391,
	"./se/nonwordRepetition/adult/trial/Trial1-if-wrong.mp3": 86098,
	"./se/nonwordRepetition/adult/trial/Trial1.mp3": 38317,
	"./se/nonwordRepetition/adult/trial/trial 1(3)-after-10-sek-if-correct.mp3": 36155,
	"./se/nonwordRepetition/adult/trial/trial1-after-10-sek-if-unanswered.mp3": 2517,
	"./se/nonwordRepetition/adult/trial/trial1-after-10-sek-if-wrong.mp3": 3224,
	"./se/nonwordRepetition/distractions/1-4-adp9Bwg9.mp3": 98450,
	"./se/nonwordRepetition/distractions/1-Klapp (1).mp3": 54531,
	"./se/nonwordRepetition/distractions/2-Fargene (1).mp3": 96622,
	"./se/nonwordRepetition/distractions/3-Tall (1).mp3": 23848,
	"./se/nonwordRepetition/distractions/4 things that has the same shape.mp3": 20417,
	"./se/nonwordRepetition/distractions/Animals.mp3": 5110,
	"./se/nonwordRepetition/distractions/Items in same color.mp3": 20600,
	"./se/nonwordRepetition/distractions/Name items in order from biggest to smallest.mp3": 29116,
	"./se/nonwordRepetition/distractions/Name items.mp3": 13799,
	"./se/pauses/begin-next-old.mp3": 65057,
	"./se/pauses/begin-next.mp3": 4694,
	"./se/pauses/brajob.mp3": 25127,
	"./se/pauses/endTest.mp3": 9284,
	"./se/pauses/goodjob-new.mp3": 7801,
	"./se/pauses/goodjob.mp3": 47828,
	"./se/pauses/rapidnaming.mp3": 99166,
	"./se/phonemeDeletion/SWFUC2-02.mp3": 97718,
	"./se/phonemeDeletion/SWFUC2-03.mp3": 78973,
	"./se/phonemeDeletion/SWFUC2-04.mp3": 21483,
	"./se/phonemeDeletion/SWFUC2-05.mp3": 41028,
	"./se/phonemeDeletion/SWFUC2-06.mp3": 93886,
	"./se/phonemeDeletion/SWFUC2-07.mp3": 60566,
	"./se/phonemeDeletion/SWFUC2-08.mp3": 79871,
	"./se/phonemeDeletion/SWFUC2-09.mp3": 99074,
	"./se/phonemeDeletion/SWFUC2-10.mp3": 33696,
	"./se/phonemeDeletion/SWFUC2-11.mp3": 20387,
	"./se/phonemeDeletion/SWFUC2-12.mp3": 8143,
	"./se/phonemeDeletion/SWFUC2-13.mp3": 68918,
	"./se/phonemeDeletion/SWFUC2-14.mp3": 69300,
	"./se/phonemeDeletion/SWFUC2-15.mp3": 95917,
	"./se/phonemeDeletion/SWFUC2-16.mp3": 25833,
	"./se/phonemeDeletion/SWFUC2-17.mp3": 31560,
	"./se/phonemeDeletion/SWFUC2-18.mp3": 90505,
	"./se/phonemeDeletion/SWFUC2-19.mp3": 89814,
	"./se/phonemeDeletion/SWFUC2-20.mp3": 95594,
	"./se/phonemeDeletion/SWFUC2-21.mp3": 75910,
	"./se/phonemeDeletion/SWFUC2-22.mp3": 172,
	"./se/phonemeDeletion/SWFUC2-23.mp3": 21565,
	"./se/phonemeDeletion/SWFUC2-24.mp3": 45535,
	"./se/phonemeDeletion/pd_sound.mp3": 44193,
	"./se/rapidNaming/rapidNaming-intro1.mp3": 33195,
	"./se/rapidNaming/rapidNaming-intro2.mp3": 29202,
	"./se/rapidNaming/rapidNaming-intro3.mp3": 57857,
	"./se/rapidNaming/rapidNaming-intro4.mp3": 92242,
	"./se/rapidNaming/rapidNaming-intro5.mp3": 35194,
	"./se/sentencememory/adult/test/S-1.mp3": 99424,
	"./se/sentencememory/adult/test/S-10.mp3": 65274,
	"./se/sentencememory/adult/test/S-11.mp3": 69623,
	"./se/sentencememory/adult/test/S-12.mp3": 9703,
	"./se/sentencememory/adult/test/S-13.mp3": 81001,
	"./se/sentencememory/adult/test/S-14.mp3": 38867,
	"./se/sentencememory/adult/test/S-15.mp3": 77383,
	"./se/sentencememory/adult/test/S-2.mp3": 42028,
	"./se/sentencememory/adult/test/S-3.mp3": 71218,
	"./se/sentencememory/adult/test/S-4.mp3": 91445,
	"./se/sentencememory/adult/test/S-5.mp3": 50528,
	"./se/sentencememory/adult/test/S-6.mp3": 76731,
	"./se/sentencememory/adult/test/S-7.mp3": 58470,
	"./se/sentencememory/adult/test/S-8.mp3": 54066,
	"./se/sentencememory/adult/test/S-9.mp3": 62445,
	"./se/sentencememory/adult/trial/A TRIAL 1-if-correct.mp3": 280,
	"./se/sentencememory/adult/trial/A TRIAL 1.mp3": 54090,
	"./se/sentencememory/adult/trial/A TRIAL1-if-wrong.mp3": 70750,
	"./se/sentencememory/adult/trial/SM-ST-O1-wrong.mp3": 2066,
	"./se/sentencememory/test/S-1.mp3": 75123,
	"./se/sentencememory/test/S-10.mp3": 81557,
	"./se/sentencememory/test/S-11.mp3": 54747,
	"./se/sentencememory/test/S-12.mp3": 24352,
	"./se/sentencememory/test/S-13.mp3": 59114,
	"./se/sentencememory/test/S-14.mp3": 65654,
	"./se/sentencememory/test/S-15.mp3": 79677,
	"./se/sentencememory/test/S-2.mp3": 55648,
	"./se/sentencememory/test/S-3.mp3": 71330,
	"./se/sentencememory/test/S-4.mp3": 81280,
	"./se/sentencememory/test/S-5.mp3": 92344,
	"./se/sentencememory/test/S-6.mp3": 56450,
	"./se/sentencememory/test/S-7.mp3": 23415,
	"./se/sentencememory/test/S-8.mp3": 73155,
	"./se/sentencememory/test/S-9.mp3": 91143,
	"./se/sentencememory/trial/A TRIAL 1-if-correct.mp3": 93029,
	"./se/sentencememory/trial/A TRIAL 1.mp3": 82806,
	"./se/sentencememory/trial/A TRIAL1-if-wrong.mp3": 91501,
	"./se/sentencememory/trial/SM-ST-O1-wrong.mp3": 86122,
	"./se/spoonerism/1.mp3": 79809,
	"./se/spoonerism/10.mp3": 29659,
	"./se/spoonerism/11.mp3": 54165,
	"./se/spoonerism/12.mp3": 93693,
	"./se/spoonerism/13.mp3": 29625,
	"./se/spoonerism/14.mp3": 23901,
	"./se/spoonerism/15.mp3": 23841,
	"./se/spoonerism/16.mp3": 56468,
	"./se/spoonerism/2.mp3": 98957,
	"./se/spoonerism/3.mp3": 97906,
	"./se/spoonerism/4.mp3": 64805,
	"./se/spoonerism/5.mp3": 40076,
	"./se/spoonerism/6.mp3": 75175,
	"./se/spoonerism/7.mp3": 28059,
	"./se/spoonerism/8.mp3": 79053,
	"./se/spoonerism/9.mp3": 84442,
	"./se/spoonerism/correct-1.mp3": 46010,
	"./se/spoonerism/incorrect-1.mp3": 80436,
	"./se/spoonerism/intro-end-spoonerism.mp3": 65959,
	"./se/spoonerism/intro-end.mp3": 31439,
	"./se/spoonerism/intro-spoonerism.mp3": 39053,
	"./se/spoonerism/proveoppgave-1.mp3": 32086,
	"./se/workingmemory_numbers/correct-1.mp3": 72313,
	"./se/workingmemory_numbers/incorrect-1.mp3": 61687,
	"./se/workingmemory_numbers/se_instruct_numbers.mp3": 78869,
	"./se/workingmemory_numbers/wmTrial-numbers-1.mp3": 20405,
	"./se/workingmemory_numbers/workingmemory-numbers-1.mp3": 92081,
	"./se/workingmemory_numbers/workingmemory-numbers-10.mp3": 22651,
	"./se/workingmemory_numbers/workingmemory-numbers-11.mp3": 88841,
	"./se/workingmemory_numbers/workingmemory-numbers-12.mp3": 80661,
	"./se/workingmemory_numbers/workingmemory-numbers-2.mp3": 69715,
	"./se/workingmemory_numbers/workingmemory-numbers-3.mp3": 64988,
	"./se/workingmemory_numbers/workingmemory-numbers-4.mp3": 78603,
	"./se/workingmemory_numbers/workingmemory-numbers-5.mp3": 55539,
	"./se/workingmemory_numbers/workingmemory-numbers-6.mp3": 44596,
	"./se/workingmemory_numbers/workingmemory-numbers-7.mp3": 16374,
	"./se/workingmemory_numbers/workingmemory-numbers-8.mp3": 68365,
	"./se/workingmemory_numbers/workingmemory-numbers-9.mp3": 59063,
	"./se/workingmemory_words/wmTrial-words-1.mp3": 44501,
	"./se/workingmemory_words/workingmemory-words-1.mp3": 59441,
	"./se/workingmemory_words/workingmemory-words-10.mp3": 11046,
	"./se/workingmemory_words/workingmemory-words-11.mp3": 66111,
	"./se/workingmemory_words/workingmemory-words-12.mp3": 69144,
	"./se/workingmemory_words/workingmemory-words-2.mp3": 93455,
	"./se/workingmemory_words/workingmemory-words-3.mp3": 48836,
	"./se/workingmemory_words/workingmemory-words-4.mp3": 9566,
	"./se/workingmemory_words/workingmemory-words-5.mp3": 64075,
	"./se/workingmemory_words/workingmemory-words-6.mp3": 64255,
	"./se/workingmemory_words/workingmemory-words-7.mp3": 69157,
	"./se/workingmemory_words/workingmemory-words-8.mp3": 74661,
	"./se/workingmemory_words/workingmemory-words-9.mp3": 41793
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91561;